module.exports = __webpack_public_path__ + "static/media/shieldLogo.9fd391b5.svg";